module.exports = __webpack_public_path__ + "static/media/phone-call (1).839d155d.svg";